export default __webpack_public_path__ + "./images/mt.6b5db2a7.png";